module.exports = __webpack_public_path__ + "static/img/news-banner.ff3b989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-banner.png
// module id = tzan
// module chunks = 1